<template lang="pug">
nav.global24__nav.white
  .global24__nav__left
    logo.white(v-if="!isGuru")
    logoGuru.white(v-else)
    .button__dd-header(style="display:flex;")
            .button.button__outline.button__gray.button__icon_right
              span {{$i18n.locale}}
              icon(name="downArrow")
            .button__dd-header_child.toup-dd
              .button__dd-header_child_scroll
                .button__dd-header_child_item.wsn(v-for="lng in langs",
                  @click="switchLang(lng.code)") {{ lng.name }}
    //- services-menu(exclude="afisha", :lang="lang", :test="test")
    search-line(:search="search", @focus="showResults = true", @blur="showResults = false",
      v-model="searchStr", theme="white")
    transition(name="fade")
      search-results(v-if="showResults", :results="results", @clicked="clearSearch")

  .global24__nav__right
    // client-only
      //-location.popupArch(:name="cityActive.name" @click="toggleCities(!cActive)" :active="cActive",
        theme="white")
      //- dialog
      //- transition(name="fade")
        popup.white(v-if="locDialog", @close="locDialog = false")
          template(#title) {{$t('msgs.isYourCity')}}
          .global24__nav__location__dialog
            btn(:name="$t('common.yes')", @click="locationDialog('yes')", active)
            btn(:name="$t('msgs.chsAnother')", @click="locationDialog('other')")
      //- window
      //- transition(name="fade")
        popup.white(v-if="cActive", @close="toggleCities(false)", close-on-outside,
        no-reflection="popupArch")
          template(#title) {{$t('msgs.chsCity')}}
          .global24__nav__location__window
            template(v-for="reg in cities")
              .reg-label {{reg.name}}
              template(v-for="city in reg.cities")
                cor-btn(@click="locationPath(city)",:active="cityActive.id === city.id")
                  | {{ city.name }}
    .global24__nav__user
      //- favorite
      login(theme="white", @click="showLoginWindow()", :active="lActive", :loading="loginAwait")

//- nav.global24__nav
  logo

  .global24__nav__menu
    template(v-for="item in menuItems")
      template(v-if="isAbsoluteLink(item.url)")
        menu-item-link(:href="createLink(item.url)") {{ item.name }}
      template(v-else)
        menu-item-nuxt(:to="createLink(item.url)", :active="isActive(item.url)") {{ item.name }}

  search-line(:search="search", @focus="showResults = true", @blur="showResults = false",
    v-model="searchStr", theme="white")
  transition(name="fade")
    search-results(v-if="showResults", :results="results", @clicked="clearSearch")
  client-only
    location.popupArch(:name="cityActive.name" @click="toggleCities(!cActive)" :active="cActive")
    //- dialog
    transition(name="fade")
      popup(v-if="locDialog", @close="locDialog = false")
        template(#title) {{$t('msgs.isYourCity')}}
        .global24__nav__location__dialog
          btn(name="Да", @click="locationDialog('yes')", active)
          btn(name="Выбрать другой", @click="locationDialog('other')")
    //- window
    transition(name="fade")
      popup(v-if="cActive", @close="toggleCities(false)", close-on-outside,
      no-reflection="popupArch")
        template(#title) {{$t('msgs.chsCity')}}
        .global24__nav__location__window
          template(v-for="reg in cities")
            .reg-label {{reg.name}}
            template(v-for="city in reg.cities")
              cor-btn(@click="locationPath(city)",:active="cityActive.id === city.id")
                | {{ city.name }}

  .global24__nav__user
    //- favorite
    login(@click="showLoginWindow()", :active="lActive", :loading="loginAwait")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import {
  Place,
  Event,
  Video,
  Name,
  Tour,
  PostOnService,
} from 'common@/instances/search';

import Logo from 'components@/_logo/afisha';
import LogoGuru from 'components@/_logo/guru';
import SearchLine from 'components@/_search/line';
import SearchResults from 'components@/_search/resultsCab';
import Popup from 'components@/_popup/popup';

import MenuItems from 'components@/_buttons/menu-item';
import Location from 'components@/_buttons/location';
import Favorite from 'components@/_buttons/favorite';
import Login from 'components@/_buttons/login';
import Btn from 'components@/_buttons/btn';
import NLink from 'components@/_buttons/n-link';
import CorBtn from 'components@/_buttons/cor-btn';
import icon from 'components@/icons';

export default {
  components: {
    Logo,
    LogoGuru,
    MenuItemNuxt: MenuItems.nuxt,
    MenuItemLink: MenuItems.link,
    SearchLine,
    SearchResults,
    Location,
    Favorite,
    Popup,
    Btn,
    Login,
    NLink,
    CorBtn,
    icon
  },
  props: {
    loginAwait: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    locSelect: false,
    locDialog: false,
    results: [],
    timer: null,
    showResults: false,
    searchStr: '',
    test: false,
    isGuru: false,
    currentDomain: '',
  }),
  computed: {
    project() {
      return this.$store.state.project;
    },
    lang() {
      return this.$store.state.lang;
    },
    currentLang() {
      return this.$store.state.locale;
    },
    layout() {
      return this.$store.state.layout;
    },
    langs() {
      if (this.layout) {
        return this.layout.langs;
      }
      return 'ru';
    },
    region() {
      if (this.$store.state.cities.currentCity && this.$store.state.cities.currentCity.slug) {
        return this.$store.state.cities.currentCity.slug;
      }
      return this.$store.state.cities.defaultSlug;
    },
    menuItems() {
      const mi = this.$store.state.pages.layout;
      return mi.menu;
    },
    cities() {
      const list = [];
      const { countries } = this.$store.state.pages.layout;
      countries.forEach((country) => {
        country.regions.forEach((region) => {
          list.push(region);
        });
      });
      return list;
    },
    cityList() {
      const mi = this.$store.state.cities.citiesList;
      return mi;
    },
    cityActive() {
      const mi = this.$store.state.cities.currentCity;
      return mi;
    },
    ...mapGetters({
      lActive: 'user/isLogged',
      cActive: 'popup/cities',
    }),
  },
  beforeMount() {
    this.test = !global.window.location.href.match(/^https:\//);
  },
  mounted() {
    this.currentDomain = window.location.hostname;
    if (!this.$cookies.isKey('city')) {
      setTimeout(() => {
        this.locDialog = true;
      }, 1500);
    }
    if (window.location.href.includes('guru') && !(window.location.href.includes('guru.ge'))) this.isGuru = true;
  },
  methods: {
    ...mapActions({
      toggleCities: 'popup/cities',
    }),
    isActive(url) {
      if (url === 'objects') {
        return this.$route.name.indexOf(url) > -1;
      }
      if (url === 'afisha') {
        return this.$route.name.indexOf('index') > -1;
      }
      return false;
    },
    isAbsoluteLink(url) {
      let abs = false;
      if (url === 'journal' || url === 'skidki') {
        return true;
      }
      abs = url.match(/^https?:\//);
      return abs;
    },
    createLink(url) {
      let isProd = true;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      if (url.match(/^https?:\//)) {
        return url;
      }
      return {
        afisha: this.localePath('/'),
        objects: this.localePath({
          name: 'region-objects',
          params: { region: this.cityActive.slug },
        }),
        journal: isProd ? 'https://24guru.by/ru' : 'http://24.24guru.by/ru',
        skidki: isProd ? 'https://24skidki.by' : 'http://skidki.24.24guru.by',
      }[url];
    },

    showLoginWindow() {
      let isProd = false;
      let isAfishaDomain = true;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      if (window.location.href.match(/localhost/) || window.location.href.match(/guru.ge/)) {
        isAfishaDomain = false;
      }
      if (this.lActive && !isAfishaDomain) {
        window.location.href = 'https://cabinet.guru.ge';
        return;
      }
      if (this.lActive) {
        window.location.href = isProd ? 'https://cabinet.24afisha.by' : 'http://cabinet.24.24guru.by';
        return;
      }
      this.$store.commit('popup/login', true);
    },
    locationPath(item) {
      this.$cookies.set('city', item.slug, '1y');
      this.$store.dispatch('cities/allBySlug', item.slug);
      if (Object.prototype.hasOwnProperty.call(this.$root, 'wizard') && this.$root.wizard) {
        this.$root.wizard.city(item.slug);
      }
      const { params } = this.$route;
      params.region = item.slug;
      this.$router.push({
        name: this.$route.name,
        params,
      });
      this.toggleCities(false);
    },
    getPath(slug) {
      return this.localePath(slug);
    },
    locationDialog(e) {
      if (e === 'yes') {
        this.$cookies.set('city', this.cityActive.slug, '1y');
        if (Object.prototype.hasOwnProperty.call(this.$root, 'wizard') && this.$root.wizard) {
          this.$root.wizard.city(this.cityActive.slug);
        }
        this.locDialog = false;
        return;
      }
      this.locDialog = false;
      this.locSelect = true;
    },
    search(e) {
      const config = {
        pathFunc: this.localePath,
        region: this.$cookies.get('city') || (this.currentDomain.includes('.by') ? 'minsk' : 'tbilisi'),
        lang: this.$cookies.get('locale') || (this.currentDomain.includes('.ge') ? 'ge' : 'ru'),
        // eslint-disable-next-line max-len
        // service: window.location.href.match(/^https:\//) ? 'https://24guru.by' : 'http://24.24guru.by',
        service: window.location.href.includes('.by') ? 'https://24afisha.by' : 'https://guru.ge',
      };

      if (!e.target.value || !e.target.value.length) {
        this.results = [];
        this.showResults = false;
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.$axios.get('/api/v2/search', {
          params: {
            target: 'site',
            'search[query]': e.target.value,
            'search[type]': 1,
          },
        }).then((r) => {

          this.showResults = true;
          this.results = [
            ...r.data.objects.items.map(e => new Place(e, config, 'region-objects-id-object', this.$t('common.places'))),
            ...r.data.posts.items.map(e => new PostOnService(e, config, this.$t('common.journal'))),
            ...r.data.videos.items.map(e => new Video(e, config, 'region-videos-id')),
            ...r.data.names.items.map(e => new Name(e, config, 'other-names-id')),
            ...r.data.tours.items.map(e => new Tour(e, config, 'other-tours-id')),
          ];

          // В поиске при запросе /api/v2/search если ищем не performance, то в ответе приходит пустой массив performances, из-за чего падает метод map, т.к. он не может итерировать items, которых нет
          if (r.data.performances && r.data.performances.items) {
            this.results.unshift(...r.data.performances.items.map(e => new Event(e, config, 'region-events-id-event', this.$t('common.afisha'))));
          }
          this.searchStr = e.target.value;
        });
      }, 500);
    },
    clearSearch() {
      this.searchStr = '';
    },
    switchLang(newLocale) {
      this.$i18n.locale = newLocale;
      window.localStorage.setItem('lang', newLocale);
      window.location.reload();
    },
  },
};
</script>
<style lang="scss">

  @media screen and (max-width: 960px) {
    .white.gu24__search-line {
      max-width: 10rem !important;
    }
    .white .global24__nav__left {
      flex: none !important;
    }
  }

</style>
